import Product from "./Product";

export default class FeaturedProduct extends Product {
    constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad, true);
    }

    loadSlider = () => {
        this.$element.find('.homepage-sections--indiv-product-slider').flexslider({
            directionNav: false,
            slideshow: false,
            animation: "slide"
        });
    }
}
